<template>
  <acWrap>
    <div class="rg-con">
      <p class="rg-head"><span>{{name}}</span></p>
      <div class="rg-content">
        <acRegistry @change="change"></acRegistry>
      </div>
    </div>
  </acWrap>
</template>
<script>
import acWrap from './components/Wrap.vue'
import acRegistry from '../../components/account/Registry.vue'
export default {
  data() {
    return {
      name: '注册账号'
    }
  },
  methods: {
    change(num) {
      switch (num) {
        case 1:
          this.name = '短信验证'
          break;
        case 2:
          this.name = '设置密码'
          break;
        default:
          this.name = '注册账号'
          break;
      }
    }
  },
  components: {
    acWrap,
    acRegistry
  }
}

</script>
<style lang="stylus" scoped>
.rg-con {
  width: 700px;
  height: 100%;
  margin: 0 auto;
  .rg-head {
    text-align: left;
    text-indent: 240px;
    line-height: 150px;
    font-size: 16px;
    color: #333333;
    span {
      position: relative;
      &:after {
        content: "";
        width: 0;
        height: 0;
        visibility: hidden;
        display: block;
        clear: both;
        overflow: hidden;
      }
    }
  }
  .rg-content {
    width: 100%;
    height: calc( 100% - 150px);
    position: relative;
  }
}

</style>



// WEBPACK FOOTER //
// Registry.vue?6f6651f8